import React from "react";
import { PHONE, track } from "../lib/contact";

export default function MessageLinks({ where }: { where: string }) {
  if (!PHONE) return null;
  const cls = "text-text underline-offset-4 hover:underline";
  return (
    <p className="text-[13px] text-muted">
      Prefer to message?{" "}
      <a
        href={`https://wa.me/${PHONE}`}
        className={cls}
        onClick={() => track("contact_click", { channel: "whatsapp", where })}
      >
        WhatsApp
      </a>{" "}
      or{" "}
      <a
        href={`sms:+${PHONE}`}
        className={cls}
        onClick={() => track("contact_click", { channel: "sms", where })}
      >
        text us
      </a>
      .
    </p>
  );
}
